module.exports = __webpack_public_path__ + "01f43047/img/scraper-icon.df6ccde5.svg";